<template>

  <span 
    :class="classes" 
  >

    <span 
      :class="{value: true}"
      v-html="value" 
      :title="title"
    />
    <br v-if="addBreak">
    <span 
      v-html="upDown" 
      class="up-down"
      :title="title"
      v-if="showChange&&this.direction !== 'none'" 
    />

    <font-awesome-icon icon="indent" class="indent-svg" :style="{ color: '#212426' }" title="Indented Result" v-if="typeof settings.hasIndent !== 'undefined' && settings.hasIndent" />

    <font-awesome-icon icon="quote-right" class="indent-svg" :style="{ color: '#212426' }" title="Featured Snippet" v-if="typeof settings.isFeatured !== 'undefined' && settings.isFeatured" />

  </span>

</template>

<script>
export default {
  name: 'RankUpDown',
  props: ['settings','tableMeta'],
  data() {
    return {
      info: this.settings
    }
  },
  computed: {

    showChange () {

     if ( !!this.tableMeta && typeof this.tableMeta.showChange !== 'undefined' && !this.tableMeta.showChange ) return false;

     return true;

    },

    title () {

      return !!this.settings.title ? this.settings.title : '';

    },

    addBreak () {

      return this.showChange && !!this.settings.addBreak;

    },

    changeRankNum () {

      if ( !this.settings.changeRank ) return 0;
      
      return parseFloat( ( this.settings.changeRank + '' ).replace('%','') );

    },

    show() {

      return ( typeof this.settings.hide === 'undefined' || this.settings.hide === false );

    },
    direction () {

      let dir;

      if ( !!this.settings.direction ) {

        dir = this.settings.direction;

      }
      else {

        if ( this.changeRankNum === 0 ) 
          dir = 'none';
        else 
          dir = this.changeRankNum > 0 ? 'up' : 'down';

      }

      return dir;

    },
    upDown() {

      const r = this.do101 ? Math.floor( this.settings.changeRank ) : this.settings.changeRank;

      let m = this.direction === 'up' ? ( '⇧' + r ) : ( '⇩' + r );

      if ( this.do101 && this.settings.value === 101 ){

        m += '+';

      }

      return m.replace('-','');

    },
    do101 () {

      return typeof this.settings.do101 !== 'undefined' && this.settings.do101 === true;

    },
    value () {

      if ( this.do101 ) {

        return this.settings.value === 101 ? '100+' : ( this.settings.value === 0 && typeof this.settings.zeroOK === 'undefined' ) ? '?' : this.settings.value;

      }

      return ( this.settings.value === 0 && ( typeof this.settings.zeroOK === 'undefined' || this.settings.zeroOK === false ) ) ? '?' : this.settings.value;

    },
    classes () {

      let c = { 'rank-up-down': true };

      if ( this.settings.align ) {

        c[this.settings.align] = true;

      }

      if ( typeof this.settings.colour !== 'undefined' ) {

        c[this.settings.colour+'-value'] = true;

      }
      else {

        let ud = ['green-up-down','red-up-down'];

        if ( !!this.settings.highBad ) ud.reverse();

        if ( this.direction === 'up' ) c[ud[0]] = true;
        if ( this.direction === 'down' ) c[ud[1]] = true;

        if ( this.settings.standardFontWeight ) c.standard = true;

        if ( !this.settings.defaultColour ) {

          if ( this.settings.value === 0 ) {

            c['red-value'] = true;

          }
          if ( this.settings.value < 10 ) {

            c['green-value'] = true;

          }
          else if ( this.settings.value < 30 ) {

            c['orange-value'] = true;

          }
          else {

            c['red-value'] = true;

          }

        }

      }

      return c;

    }

  },
  methods: {
  
    

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.rank-up-down {

  .indent-svg {
    margin-top: 4px;
    vertical-align: top;
  }

  span {

    display: inline-block;

    &.value {

      color: @darkContrast;
      border-radius: 5px;
      padding: 1px 5px 0;
      min-width: 20px;
      text-align: center;

    }

  }

  &.left {

    span {

      &.value {

       text-align: left;

      }

    }

  }

  &.right {

    span {

      &.value {

       text-align: right;

      }

    }

  }

  &:not(.standard) {

    span {

      &.value {

        font-weight: 900;

      }

    }


  }

  &.grey-value {

    span {

      &.value {

        color: @darkContrast;

      }

    }

  } 

  &.green-value {

    span {

      &.value {

        color: @green;

      }

    }

  }

  &.orange-value {

    span {

      &.value {

        color: @orange;

      }

    }

  }

  &.orange-full-value {

    span {

      &.value {

        color: @orange;

      }

    }

  }

  &.red-value {

    span {

      &.value {

        color: @red;

      }

    }

  }

  &.green-up-down {

    span {

      &.up-down {

        color: @green;

      }

    }

  }

  &.red-up-down {

    span {

      &.up-down {

        color: @red;

      }

    }

  }

}
</style>